import { GenIcon } from '../helpers/IconBase.es.js';

const FacebookFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M22 12.0599C21.9998 10.1489 21.452 8.27796 20.4215 6.66861C19.391 5.05926 17.921 3.77888 16.1854 2.97905C14.4498 2.17922 12.5214 1.89344 10.6285 2.15554C8.73552 2.41764 6.95732 3.21665 5.50437 4.45796C4.05142 5.69928 2.98457 7.33092 2.43013 9.15973C1.87569 10.9885 1.85687 12.9379 2.37591 14.7771C2.89494 16.6162 3.93009 18.2682 5.35881 19.5373C6.78752 20.8064 8.54997 21.6396 10.4375 21.9382V14.9507H7.89833V12.0599H10.4375V9.85655C10.4375 7.35072 11.9308 5.96572 14.2142 5.96572C14.9643 5.97648 15.7126 6.04165 16.4533 6.16072V8.62238H15.1917C14.8119 8.57197 14.4276 8.67445 14.1233 8.90729C13.8191 9.14013 13.6197 9.48427 13.5692 9.86405C13.5549 9.9704 13.5526 10.078 13.5625 10.1849V12.0599H16.3333L15.89 14.9507H13.5567V21.9382C15.91 21.5674 18.0537 20.3685 19.6016 18.5575C21.1495 16.7465 22.0001 14.4423 22 12.0599Z",
              fill: "#82869E"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "20",
                  height: "20",
                  fill: "white",
                  transform: "translate(2 2)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { FacebookFilled };
